import { render, staticRenderFns } from "./StartInfosAdd.vue?vue&type=template&id=37db0ba4&scoped=true&"
import script from "./StartInfosAdd.vue?vue&type=script&lang=js&"
export * from "./StartInfosAdd.vue?vue&type=script&lang=js&"
import style0 from "./StartInfosAdd.vue?vue&type=style&index=0&id=37db0ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db0ba4",
  null
  
)

export default component.exports